import {
    Component,
    ElementRef,
    EventEmitter,
    HostListener,
    Input,
    OnDestroy,
    OnInit,
    Output,
    Renderer2,
    ViewChild,
} from '@angular/core';
import { Calendar } from './calendar';
import { FormsModule } from '@angular/forms';
import { NgStyle, NgClass, DatePipe } from '@angular/common';

@Component({
    selector: 'material-datepicker',
    styleUrls: ['./datepicker.component.scss'],
    template: ` <div
        class="datepicker"
        [ngStyle]="{ 'font-family': fontFamily }">
        <input
            type="text"
            class="datepicker__input"
            [ngStyle]="{
                color: altInputStyle ? colors['white'] : colors['black'],
                'background-color': altInputStyle
                    ? accentColor
                    : colors['white'],
                border: altInputStyle ? '' : '1px solid #dadada'
            }"
            (click)="onInputClick()"
            [(ngModel)]="inputText"
            readonly="readonly"
            #inputElement />
        @if (showCalendar) {
            <div class="datepicker__calendar" #calendarElement>
                <div class="datepicker__calendar__nav">
                    <div
                        class="datepicker__calendar__nav__arrow"
                        (click)="onArrowLeftClick()">
                        <svg
                            class="datepicker__calendar__nav__chevron"
                            x="0px"
                            y="0px"
                            viewBox="0 0 50 50">
                            <g>
                                <path
                                    d="M39.7,7.1c0.5,0.5,0.5,1.2,0,1.7L29,19.6c-0.5,0.5-1.2,1.2-1.7,1.7L16.5,32.1c-0.5,0.5-1.2,0.5-1.7,0l-2.3-2.3
                    c-0.5-0.5-1.2-1.2-1.7-1.7l-2.3-2.3c-0.5-0.5-0.5-1.2,0-1.7l10.8-10.8c0.5-0.5,1.2-1.2,1.7-1.7L31.7,0.8c0.5-0.5,1.2-0.5,
                    1.7,0l2.3,2.3c0.5,0.5,1.2,1.2,1.7,1.7L39.7,7.1z" />
                            </g>
                            <g>
                                <path
                                    d="M33.4,49c-0.5,0.5-1.2,0.5-1.7,0L20.9,38.2c-0.5-0.5-1.2-1.2-1.7-1.7L8.4,25.7c-0.5-0.5-0.5-1.2,0-1.7l2.3-2.3
                    c0.5-0.5,1.2-1.2,1.7-1.7l2.3-2.3c0.5-0.5,1.2-0.5,1.7,0l10.8,10.8c0.5,0.5,1.2,1.2,1.7,1.7l10.8,10.8c0.5,0.5,0.5,1.2,0,1.7
                    L37.4,45c-0.5,0.5-1.2,1.2-1.7,1.7L33.4,49z" />
                            </g>
                        </svg>
                    </div>
                    <div class="datepicker__calendar__nav__header">
                        {{ currentMonth }} {{ currentYear }}
                    </div>
                    <div
                        class="datepicker__calendar__nav__arrow"
                        (click)="onArrowRightClick()">
                        <svg
                            class="datepicker__calendar__nav__chevron"
                            x="0px"
                            y="0px"
                            viewBox="0 0 50 50">
                            <g>
                                <path
                                    d="M8.4,7.1c-0.5,0.5-0.5,1.2,0,1.7l10.8,10.8c0.5,0.5,1.2,1.2,1.7,1.7l10.8,10.8c0.5,0.5,1.2,0.5,1.7,0l2.3-2.3
                    c0.5-0.5,1.2-1.2,1.7-1.7l2.3-2.3c0.5-0.5,0.5-1.2,0-1.7L29,13.2c-0.5-0.5-1.2-1.2-1.7-1.7L16.5,0.8c-0.5-0.5-1.2-0.5-1.7,0
                    l-2.3,2.3c-0.5,0.5-1.2,1.2-1.7,1.7L8.4,7.1z" />
                            </g>
                            <g>
                                <path
                                    d="M14.8,49c0.5,0.5,1.2,0.5,1.7,0l10.8-10.8c0.5-0.5,1.2-1.2,1.7-1.7l10.8-10.8c0.5-0.5,0.5-1.2,0-1.7l-2.3-2.3
                    c-0.5-0.5-1.2-1.2-1.7-1.7l-2.3-2.3c-0.5-0.5-1.2-0.5-1.7,0L20.9,28.5c-0.5,0.5-1.2,1.2-1.7,1.7L8.4,40.9c-0.5,
                    0.5-0.5,1.2,0,1.7l2.3,2.3c0.5,0.5,1.2,1.2,1.7,1.7L14.8,49z" />
                            </g>
                        </svg>
                    </div>
                </div>
                <div class="datepicker__calendar__content">
                    @for (day of dayNames; track day) {
                        <div class="datepicker__calendar__label">
                            {{ day }}
                        </div>
                    }
                    <div
                        id="datepicker__calendar__month"
                        class="datepicker__calendar__month"
                        [ngClass]="{
                            'datepicker__calendar__month--animate-left':
                                animateLeft,
                            'datepicker__calendar__month--animate-right':
                                animateRight
                        }">
                        @for (day of calendarDays; track day) {
                            <div
                                class="datepicker__calendar__month__day"
                                [ngStyle]="{
                                    cursor:
                                        day == 0 || !isInsideRange(day)
                                            ? 'initial'
                                            : 'pointer',
                                    'background-color':
                                        getDayBackgroundColor(day),
                                    color: getDayColor(day)
                                }"
                                (click)="onSelectDay(day)"
                                (mouseenter)="hoveredDay = day"
                                (mouseleave)="hoveredDay = null">
                                @if (day != 0) {
                                    <span>{{ day | date: 'dd' }}</span>
                                }
                            </div>
                        }
                    </div>
                    <div
                        class="datepicker__calendar__cancel"
                        (click)="onCancel()"
                        #cancelElement>
                        Cancel
                    </div>
                </div>
            </div>
        }
    </div>`,
    standalone: true,
    imports: [
        NgStyle,
        FormsModule,
        NgClass,
        DatePipe,
    ],
})
export class DatepickerComponent implements OnInit, OnDestroy {
    // api bindings
    @Input() accentColor: string;
    @Input() altInputStyle: boolean;
    @Input() date: Date;
    @Input() fontFamily: string;
    @Input() rangeStart: Date;
    @Input() rangeEnd: Date;
    //
    @Input() animateLeft: boolean;
    @Input() animateRight: boolean;
    @Input() calendarDays: Array<number>;
    @Input() currentMonth: string;
    @Input() dayNames: Array<string>;
    @Input() hoveredDay: Date | number | null;
    @Input() inputText: string;
    @Input() showCalendar: boolean;
    @Output() select = new EventEmitter<Date>();

    @ViewChild('calendarElement') calendarElement;
    @ViewChild('cancelElement') cancelElement;
    @ViewChild('inputElement') inputElement;

    animationListener: any;
    calendar: Calendar;
    colors: any;
    currentMonthNumber: number;
    currentYear: number;
    months: Array<string>;

    constructor(
        private elementRef: ElementRef,
        private renderer: Renderer2,
    ) {
        // view logic
        this.showCalendar = false;
        // colors
        this.colors = {
            black: '#333333',
            blue: '#1285bf',
            lightGrey: '#f1f1f1',
            white: '#ffffff',
        };
        this.accentColor = this.colors.black;
        this.altInputStyle = false;
        // time
        this.calendar = new Calendar();
        this.dayNames = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];
        this.months = [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            ' December',
        ];
        // animations
        this.animationListener = null;
        this.animateLeft = false;
        this.animateRight = false;
    }

    ngOnInit() {
        this.initComponent();
    }

    onInputClick() {
        this.initComponent();

        this.showCalendar = !this.showCalendar;
        this.addOrRemoveAnimationListener();
    }

    ngOnDestroy() {
        this.removeAnimationListener();
    }

    addAnimationListener() {
        if (this.showCalendar) {
            const element = document.getElementById(
                'datepicker__calendar__month',
            );
            if (element) {
                this.animationListener = this.renderer.listen(
                    element,
                    'animationend',
                    event => {
                        this.animateLeft = false;
                        this.animateRight = false;
                    },
                );
            }
        }
    }

    getDayBackgroundColor(day: Date | number): string {
        let color = this.colors.white;
        if (this.isChosenDay(day)) {
            color = this.accentColor;
        } else if (this.isCurrentDay(day)) {
            color = this.colors.lightGrey;
        }
        return color;
    }

    getDayFontColor(day: Date | number) {
        let color = this.colors.black;
        if (this.isChosenDay(day)) {
            color = this.colors.white;
        }
        return color;
    }

    isChosenDay(day: Date | number): boolean {
        if (day) {
            return this.date
                ? (day as Date).toDateString() === new Date(this.date).toDateString()
                : false;
        }
        return false;
    }

    isCurrentDay(day: Date | number): boolean {
        if (day) {
            return (day as Date).toDateString() === new Date().toDateString();
        }
        return false;
    }

    isHoveredDay(day: Date): boolean {
        return this.hoveredDay
            ? this.hoveredDay === day && !this.isChosenDay(day)
            : false;
    }

    setCurrentMonth(monthNumber: number) {
        this.currentMonth = this.months[monthNumber];
        const calendarArray: any[] = this.calendar.monthDays(
            this.currentYear,
            this.currentMonthNumber,
        );
        this.calendarDays = [].concat(...calendarArray);
    }

    setHoveredDay(day: Date) {
        this.hoveredDay = day;
    }

    removeHoveredDay(day: Date) {
        this.hoveredDay = null;
    }

    setInputText(date: Date) {
        let month: string = (date.getMonth() + 1).toString();
        if (month.length < 2) {
            month = `0${month}`;
        }
        let day: string = date.getDate().toString();
        if (day.length < 2) {
            day = `0${day}`;
        }
        this.inputText = `${day}-${month}-${date.getFullYear()}`;
    }

    removeAnimationListener() {
        if (this.animationListener) {
            this.animationListener();
        }
    }

    // Click Handlers
    // ------------------------------------------------------------------------------------//
    onArrowLeftClick() {
        const currentMonth: number = this.currentMonthNumber;
        let newYear: number = this.currentYear;
        let newMonth: number;

        if (currentMonth === 0) {
            newYear = this.currentYear - 1;
            newMonth = 11;
        } else {
            newMonth = currentMonth - 1;
        }

        const newDate = new Date(newYear, newMonth);
        if (
            !this.rangeStart ||
            newDate.getTime() >= this.getMonthRangeAsTime(this.rangeStart)
        ) {
            this.currentYear = newYear;
            this.currentMonthNumber = newMonth;
            this.setCurrentMonth(newMonth);
            this.animateLeft = true;
        }
    }

    onArrowRightClick() {
        const currentMonth: number = this.currentMonthNumber;
        let newYear: number = this.currentYear;
        let newMonth: number;

        if (currentMonth === 11) {
            newYear = this.currentYear + 1;
            newMonth = 0;
        } else {
            newMonth = currentMonth + 1;
        }

        const newDate = new Date(newYear, newMonth);
        if (
            !this.rangeEnd ||
            newDate.getTime() <= this.getMonthRangeAsTime(this.rangeEnd)
        ) {
            this.currentYear = newYear;
            this.currentMonthNumber = newMonth;
            this.setCurrentMonth(newMonth);
            this.animateRight = true;
        }
    }

    onCancel() {
        this.showCalendar = false;
        this.addOrRemoveAnimationListener();
    }

    private initComponent() {
        const windowObj = <any>window;

        let date: Date;
        if (this.date) {
            date = this.date;
            this.setInputText(this.date);
        } else {
            date = new Date();
        }

        if (windowObj.primaryColor) {
            this.accentColor = windowObj.primaryColor;
        }

        this.currentMonthNumber = date.getMonth();
        this.currentMonth = this.months[this.currentMonthNumber];
        this.currentYear = date.getFullYear();

        const calendarArray: any = this.calendar.monthDays(
            this.currentYear,
            this.currentMonthNumber,
        );
        this.calendarDays = [].concat(...calendarArray);
    }

    addOrRemoveAnimationListener() {
        if (this.showCalendar) {
            window.setTimeout(() => this.addAnimationListener(), 1000);
        } else {
            this.removeAnimationListener();
        }
    }

    onSelectDay(day: Date | number) {
        if (day && this.isInsideRange(day as Date)) {
            this.removeAnimationListener();
            this.date = day as Date;
            this.setInputText(day as Date);
            this.showCalendar = !this.showCalendar;
            this.select.emit(day as Date);
        }
    }

    isInsideRange(day: Date | number) {
        // Remove time discrepancies
        new Date(this.rangeStart)?.setHours(0, 0, 0, 0);

        if (this.date && !this.rangeEnd) {
            // If only one date is selected, consider it as the range start and end
            return (day as Date).getTime() === this.date.getTime();
        }

        const afterStart =
            !this.rangeStart ||
            (day as Date).getTime() >= this.rangeStart.getTime();
        const beforeEnd =
            !this.rangeEnd ||
            (day as Date).getTime() <= this.rangeEnd.getTime();

        return afterStart && beforeEnd;
    }

    getDayColor(day: Date | number) {
        if (day && this.isInsideRange(day as Date)) {
            return this.isHoveredDay(day as Date)
                ? this.accentColor
                : this.getDayFontColor(day as Date);
        }
        return this.colors.lightGrey;
    }

    /**
     * Close calendar when clicking outside
     *
     * @param event
     */
    @HostListener('document:click', ['$event'])
    handleClickOutside(event) {
        if (this.calendarElement) {
            const clickedComponent = event.target;

            // Check if click is not on cancel button or input
            const cancelClicked = this.checkIfChildElementClicked(
                clickedComponent,
                this.cancelElement.nativeElement,
            );
            const inputClicked = this.checkIfChildElementClicked(
                clickedComponent,
                this.inputElement.nativeElement,
            );

            if (!cancelClicked && !inputClicked) {
                // Check for outside click if the button was not clicked
                const insideClicked = this.checkIfChildElementClicked(
                    clickedComponent,
                    this.calendarElement.nativeElement,
                );

                if (!insideClicked) {
                    this.showCalendar = false;
                    this.addOrRemoveAnimationListener();
                }
            }
        }
    }

    /**
     * Recursive function to check if a child element of the given parent was clicked
     * @param clickedComponent
     * @param parentComponent
     * @returns {boolean}
     */
    checkIfChildElementClicked(clickedComponent, parentComponent): boolean {
        let childClicked = false;
        do {
            if (clickedComponent === parentComponent) {
                childClicked = true;
            }
            clickedComponent = clickedComponent.parentNode;
        } while (clickedComponent);

        return childClicked;
    }

    /**
     * Shorthand to validate paging between months
     *
     * @param rangeDate
     * @returns {number}
     */
    private getMonthRangeAsTime(rangeDate: Date) {
        return new Date(
            rangeDate.getFullYear(),
            rangeDate.getMonth(),
        ).getTime();
    }
}
